type TrackParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

/**
 * Push a custom event to the GTM dataLayer and mirror it to PostHog. Both
 * trackers are injected at build time by vite-plugin-radar (VITE_GTM_TAG_ID /
 * VITE_POSTHOG_KEY+HOST); each sink degrades to a no-op when absent. Events
 * pushed before the GTM snippet loads are replayed by GTM once it initializes;
 * the PostHog stub queues captures the same way.
 */
export const trackEvent = (event: string, params: TrackParams = {}): void => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  window.posthog?.capture?.(event, params);
};
